import styled from 'styled-components';

const StyledListChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  padding: 10px;
`;

const StyledListChartSvg = styled.svg`
  z-index: 1;
`;

const StyledListChartContent = styled.div`
  height: 100%;
  overflow: hidden auto;
`;

const StyledListItem = styled.div`
  width: 100%;
  height: 86px;
  border-bottom: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  position: relative;
`;

const StyledListItemContent = styled.div`
  width: 83%;
  display: flex;
  align-items: left;
  flex-direction: column;
  padding-left: 10px;
`;

const StyledListItemTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: rgb(148, 147, 166);
`;

const StyledListItemSubTitle = styled.div`
  padding-top: 10px;
  font-size: 11px;
  font-weight: 300;
  color: rgb(148, 147, 166);
`;

const StyledListItemValue = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgb(148, 147, 166);
  margin-right: 10px;
`;

const StyledListChartMetric = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: rgb(148, 147, 166);
  margin-right: 10px;
  text-align: end;
`;

export {
  StyledListChartWrapper,
  StyledListChartSvg,
  StyledListChartContent,
  StyledListItem,
  StyledListItemContent,
  StyledListItemTitle,
  StyledListItemSubTitle,
  StyledListItemValue,
  StyledListChartMetric
};
